import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import MobileItem from '@wetransfer/transfer/component/navigation/mobileitem';
import { TransferAccountMenu } from '@wetransfer/transfer/component/TransferAccountMenu/TransferAccountMenu';
import { getPlanTier } from '@wetransfer/transfer/helper/user';
import Analytics from '@wetransfer/transfer/modules/analytics';
import Store from '@wetransfer/transfer/store';
import Actions from '@wetransfer/transfer/store/action';

// We'll probably make this toggle so the default links won't work.

export default class MobileNavigation extends React.Component {
  static propTypes = {
    route: PropTypes.object,
    menuItems: PropTypes.array,
    style: PropTypes.object,
    isLoading: PropTypes.bool,
    user: PropTypes.object,
    isLogOutPending: PropTypes.bool,
    auth0UserId: PropTypes.string,
  };

  /**
   * Binds all private methods
   * @param  {Object} props Component props
   */
  constructor(props) {
    super(props);

    this.state = {
      showSubNav: false,
      subSubNavOpen: false,
    };

    this.closeMenu = this.closeMenu.bind(this);
    this.onNavigation = this.onNavigation.bind(this);
    this.onGlobalClick = this.onGlobalClick.bind(this);
    this.doSignout = this.doSignout.bind(this);
    this.toggleSubSubNav = this.toggleSubSubNav.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    const hamburgerListElement = this.node.querySelector('li.hamburger-icon');
    const hamburgerIcon = this.node.querySelector('svg.hamburger');

    // Check if the event target is a list item that contains hamburger or the hamburger elements.
    // This check is needed to avoid triggering additional click event when you click on items in subnavigation.
    if (
      e.target === hamburgerListElement ||
      (hamburgerIcon && hamburgerIcon.contains(e.target))
    ) {
      const hideAllSubMenus = this.state.showSubNav;
      this.setState({
        showSubNav: !this.state.showSubNav,
        ...(hideAllSubMenus && { subSubNavOpen: false }),
      });
    }
  }

  onNavigation(path, trackEvent = null) {
    if (path === '/signout') {
      Store.dispatch(Actions.User.signout());

      return;
    }

    if (trackEvent) {
      Analytics.trackSnowplowEvent({
        category: trackEvent.category,
        action: trackEvent.action,
        property: trackEvent.property,
        label: trackEvent.label,
      });
    }

    this.closeMenu();
  }

  doSignout() {
    Store.dispatch(Actions.User.signout());
  }

  onGlobalClick(e) {
    if (e.target === this.node || this.node.contains(e.target)) {
      return;
    }

    this.closeMenu();
  }

  closeMenu() {
    this.setState({
      showSubNav: false,
      subSubNavOpen: false,
    });
  }

  toggleSubSubNav(event) {
    event.stopPropagation();

    if (!this.state.subSubNavOpen) {
      Analytics.trackSnowplowEvent({
        category: 'navigation_bar',
        action: 'clickNavFeatures',
        label: getPlanTier(this.props.user) || 'anonymous',
      });
    }

    this.setState({ subSubNavOpen: !this.state.subSubNavOpen });
  }

  componentDidMount() {
    window.addEventListener('touchstart', this.onGlobalClick, true);
    window.addEventListener('scroll', this.closeMenu);
  }

  componentWillUnmount() {
    window.removeEventListener('touchstart', this.onGlobalClick, true);
    window.removeEventListener('scroll', this.closeMenu);
  }

  render() {
    const { isLoading, user, isLogOutPending, auth0UserId } = this.props;
    const path = this.props.route.path;

    const className = classnames('nav', {
      'nav--home': path === '/',
      'nav--plus': path === '/pro',
    });
    const menuItems = [];

    // Render all of our items
    this.props.menuItems.forEach((menuItem) => {
      // Figure out if this is the child which needs to render the subnav

      menuItems.push(
        <MobileItem
          key={`mobile-menu-item-${menuItem.id}`}
          className={classnames('nav__item', {
            'hamburger-icon': menuItem.id === 'hamburger',
          })}
          onItemClick={this.onNavigation}
          onClick={this.onClick}
          onSubSubNavClick={this.toggleSubSubNav}
          subSubNavOpen={this.state.subSubNavOpen}
          showSubNav={this.state.showSubNav}
          isLoading={isLoading}
          {...menuItem}
        />
      );
    });

    const classNameUl = classnames('nav__items', {
      'nav__items--equal-width': !user.loggedIn,
    });

    const nav = (
      <ul className={classNameUl}>
        {menuItems}
        {user.loggedIn && (
          <TransferAccountMenu
            user={user}
            isLogOutPending={isLogOutPending}
            logout={this.doSignout}
            showLabel={false}
            auth0UserId={auth0UserId}
          />
        )}
      </ul>
    );

    return (
      <nav ref={(node) => (this.node = node)} className={className}>
        {nav}
      </nav>
    );
  }
}
